import { MOUNTDOOM_2_URL, MOUNTDOOM_URL } from './environment-utils'

export const environment = {
  name: 'prod',
  production: true,
  SERVICE_WORKER: true,
  SAMMATHNAUR_BASE_URL: 'https://sammathnaur.fieldcontrol.com.br/graphql',
  MORDU_BASE_URL: 'https://mordu.fieldcontrol.com.br/graphql',
  REALTIME_URL: 'https://mouthofsauron-3-rt.fieldcontrol.com.br/corporate/notifications',
  VAPID_PUBLIC_KEY: 'BD7akf-Ek_PIMzyepmqz462dr6T48yMpxywOyC0Xc7Sunn50OsKT6rbg54byp70GJ8kRHahZ-ZaVGj6RgTVlCu8',
  MORANNON_URL: 'https://morannon.fieldcontrol.com.br',
  BLATOUT_APP_ID: '65e5470c-8cf1-44f1-ab1b-1959af90e966',
  SENTRY_DNS: 'https://f19c5e913ac149c6b45c9d8f70100171@o142032.ingest.sentry.io/5544045',
  UPLOAD_URL: 'https://ae0ce29usj.execute-api.sa-east-1.amazonaws.com/prod',
  GROUND_BASE_URL: 'https://app.fieldcontrol.com.br/relacionamento-cliente/#',
  MOUNTDOOM_URL,
  MOUNTDOOM_2_URL,
}
